import sleep from "@/utils/helpers/sleep";
import isServer from "@/utils/helpers/isServer";
import { gaEvent } from "@/components/Tracking/GA";
import { ActionType, FlowType } from "@/components/Onboarding/type";
import { capitalizeFirstLetter } from "@/utils/string";
import { getGoogleSignInReturnPath } from "@/utils/helpers/getGoogleSignInReturnPath";

type TrackingOptions = {
  skipGA?: boolean;
};

function onTracking(
  category: string,
  action: ActionType,
  flow?: FlowType,
  options?: TrackingOptions
) {
  if (typeof window !== "undefined") {
    const flowCapitalized = flow ? capitalizeFirstLetter(flow) : "";
    const newValue = `${category}${flowCapitalized}${capitalizeFirstLetter(
      action
    )}`;

    if ("clarity" in window) {
      // @ts-ignore type guarded
      window.clarity("event", newValue);
    }

    if ("gtag" in window && !options?.skipGA) {
      const labelValue = flow ? flow : category;
      // @ts-ignore type guarded
      gaEvent({
        value: flow || category,
        category,
        action,
        label: labelValue,
      });
    }
  }
}

export { sleep, isServer, onTracking, getGoogleSignInReturnPath };
